import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import {useNavigate} from "react-router-dom";
import {routeConfigs} from "../../../navigation/routeConfig";
import Box from "@mui/material/Box";
import {useQueryOrder} from "../../../queries/order/hooks/useQueryOrder";
import {CircularProgress} from "@mui/material";
import {SERVER_URL} from "../../../constants/global";
import Link from "@mui/material/Link";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

interface SuccessOrderDialogProps {
  successOrderId: null | number;
  setSuccessOrderId: (successOrderId: null | number) => void;
  refetch: any;
}

export const SuccessOrderDialog:React.FunctionComponent<SuccessOrderDialogProps> = ({
  successOrderId,
  setSuccessOrderId,
  refetch
}) => {
  const navigate  = useNavigate();

  const { loading, data } = useQueryOrder({
    variables: { where: { id: successOrderId } },
    fetchPolicy: 'no-cache'
  });

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={successOrderId !== null}
      onClose={() => {
        refetch();
        setSuccessOrderId(null)
        navigate(routeConfigs.sellHistory.path);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{fontSize: 20, fontWeight: 600, display: 'flex', alignItems: 'center'}}>
        <CheckCircleRoundedIcon color='success' sx={{mr: 1}} />
        Prepare your package for shipment
      </DialogTitle>
      {loading ? (
        <CircularProgress sx={{position: 'absolute', left: 'calc(50% - 24px)', top: '50%'}} color="inherit" />
      ) : (
        <DialogContent sx={{ height: '500px', position: 'relative' }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            '&::before': {
              content: '""',
              height: 8,
              width: 8,
              marginRight: 1,
              display: 'inline-block',
              borderRadius: '50%',
              backgroundColor: 'rgba(0, 0, 0, 0.87)',
            },
          }}
          >Include the signed Packing Checklist with the order</Box>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            '&::before': {
              content: '""',
              height: 8,
              width: 8,
              marginRight: 1,
              display: 'inline-block',
              borderRadius: '50%',
              backgroundColor: 'rgba(0, 0, 0, 0.87)',
            },
          }}
          >Make sure FedEx scans your package at that time of pickup/drop-off</Box>
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 4}}>
            { data?.findUniqueOrder?.CheckList?.key && <Link href={`${SERVER_URL}/file/${data.findUniqueOrder.CheckList.key}`} target="_blank" sx={{width: '50%', mr: 4}}>
              <Button
                fullWidth
                variant='contained'
              >
                Download Checklist
              </Button>
            </Link> }
            {data?.findUniqueOrder?.Label?.key && <Link href={`${SERVER_URL}/file/${data.findUniqueOrder.Label.key}`} target="_blank" sx={{width: '50%'}}>
              <Button
                fullWidth
                variant='contained'
              >
                Download label
              </Button>
            </Link> }
          </Box>
          <Box sx={{fontSize: 16, fontWeight: 600, mt: 4}}>Packing instructions</Box>
          <Box sx={{mt: 2}}>1. Put a double layer of bubble wrap on the bottom of the box</Box>
          <Box sx={{mt: 1}}>2. Place product (Represented by white box) on top of the bubble wrap</Box>
          <Box sx={{mt: 1}}>3. Put a double layer of bubble wrap on the top of product</Box>
          <Box sx={{mt: 1}}>4. Fill extra space in the box with bubble wrap, so no movement occurs during shipment</Box>
          <Box sx={{mt: 1}}>5. Securely tape the top of the box by fastening two strips of tape across the width of the box and one strip of tape across the length of the box</Box>
        </DialogContent>
      )}
      <DialogActions>
        <Button
          fullWidth
          variant='contained'
          onClick={() => {
            refetch();
            setSuccessOrderId(null);
            navigate(routeConfigs.sellHistory.path);
          }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );

}